import { useSlideshowContext } from '@fukku/slideshow/hooks/useSlideshowContext/useSlideshowContext'
import { SlideshowFromDirection } from '@fukku/slideshow/types/Slideshow'
import { useCallback, useMemo } from 'react'
import { useStore } from 'zustand'

export const usePreloadedItems = () => {
	const { preloadedItemsStore, hasPreload, getNewIndexFromDirection, items } =
		useSlideshowContext()

	const {
		items: preloadedItems,
		addItem,
		clearItems,
	} = useStore(preloadedItemsStore)

	const preloadNeighborItems = useCallback(
		(index: number) => {
			if (!hasPreload) {
				return
			}

			clearItems()

			const leftIndex = getNewIndexFromDirection(
				index,
				SlideshowFromDirection.Left
			)
			addItem(items[leftIndex], leftIndex)

			const rightIndex = getNewIndexFromDirection(
				index,
				SlideshowFromDirection.Right
			)
			addItem(items[rightIndex], rightIndex)
		},
		[addItem, clearItems, getNewIndexFromDirection, hasPreload, items]
	)

	return useMemo(
		() => ({ preloadedItems, preloadNeighborItems }),
		[preloadedItems, preloadNeighborItems]
	)
}
